









import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '@nuxtjs/composition-api'
import { Position } from '~/models/app/position'

export default defineComponent({
  props: {
    position: {
      type: String as PropType<Position>,
      default: Position.TOP_LEFT
    },
    rotate: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const { position, rotate } = toRefs(props)

    const sizeClasses = computed(() => {
      switch (position.value) {
        case Position.TOP_LEFT:
        default: {
          return ['tw--top-3', 'tw--left-2']
        }
        case Position.TOP_RIGHT: {
          return ['tw--top-3', 'tw--right-2']
        }
        case Position.BOTTOM_RIGHT: {
          return ['tw--bottom-3', 'tw--right-2']
        }
        case Position.BOTTOM_LEFT: {
          return ['tw--bottom-3', 'tw--left-2']
        }
        case Position.RIGHT: {
          return [
            'tw-top-0',
            'tw-left-auto',
            'tw-bottom-0',
            'tw-right-2',
            'tw-m-auto'
          ]
        }
      }
    })

    const rotateClasses = computed(() => [
      ...(rotate.value ? ['tw-rotate-[-20deg]'] : [])
    ])

    return { sizeClasses, rotateClasses }
  }
})
